import { track } from '../../../../domains/common/tracking/segment';
import { getGroupDataForRecording } from '../../utils/tracking';

import type { Recording } from '../../types';

const getUrl = (): string => window.location.pathname + window.location.search;

export const trackPlaylistItemNavigation = (
  recording: Recording | null,
  // eslint-disable-next-line camelcase
  user: { user_id: number } | null,
): void => {
  if (!recording || !user) return;
  track('Element Clicked', {
    url_event_was_triggered_on: getUrl(),
    user_id: user.user_id,
    element_name: 'Play Recording',
    state_event_was_triggered_on: 'Recordings Player',
    ui_position: `Player Mini List`,
    ...getGroupDataForRecording(recording),
  });
};

export const trackPlaylistToggle = (
  recording: Recording | null,
  userId: number,
  toggleAction: 'Collapse' | 'Expand',
): void => {
  if (!recording) return;

  track('Element Clicked', {
    url_event_was_triggered_on: getUrl(),
    user_id: userId,
    element_name: `${toggleAction} Mini List`,
    state_event_was_triggered_on: 'Recordings Player',
    ui_position: `Player Mini List`,
    ...getGroupDataForRecording(recording),
  });
};
